module.exports = {
    language: {
        title: 'Choose your language<br/>(選擇您的語言)',
        lang:'English'
    },
    start:{
        startText:"A lion is hungry！<br/>Let's feed them.",
        startButton:'START',
        openTip:'To ensure an enjoyable experience, please go to Settings->Safari->Privacy & Security, and turn on 【Motion & Orientation Access】.',
        toBrowser:'Press the button at the top right corner of the screen and select a web browser to start the game.',
        example:'Example:'
    },
    game:{
        resultText:'congratulations on becoming a ',
        saveBtn:'save',
        press:'Long press to send the picture to your friends, or download the picture and then share on wechat moments',
        trainer:' trainer',
    },
    animals:{
        lion:'Lion',
    },
    loading:{
        tipsText0:'Use your finger to swipe the screen, click on the food the animal likes, and it will like you more and more.',
        tipsText1:'Use your smart device camera to search for the food the animal should eat. Tap on the food to feed it.',
        tipsTitle:'How To Play',
        load:'Loading'
    },
    success:{
        successText:'Success',
        text:'Congratulations on<br/>Becoming a ',
        otherText:'Tame other animals',
        continueTitle:'Continue',
        playAgain:'Play again',
        understandTitle:'Understand More',
        downloadTitle:'APP Download',
        trainer:' trainer',
        apple: 'Apple',
        google: 'Google',
        xiaomi: 'Xiaomi',
        huawei: 'Huawei'
    }
}


// WEBPACK FOOTER //
// ./src/assets/common/lang/en.js